import { Reveal } from "./Reveal";

const CARDS = [
  { label: "Our Mission", body: "To empower visionary entrepreneurs and investors by connecting exceptional businesses with strategic capital, trusted relationships, and long-term partnership." },
  { label: "Our Vision", body: "To become one of the world's most respected independent strategic capital advisory firms — where founders, investors and family offices build companies that leave a lasting legacy." },
];

export const About = () => {
  return (
    <section id="about" data-testid="about" className="relative py-28 lg:py-40 border-t border-hairline">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">About Us</span>
              <h2 className="font-serif font-light text-5xl sm:text-6xl tracking-tighter text-parchment mt-6 text-balance">
                Capital with <span className="italic text-gold">purpose.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="font-serif italic text-2xl text-parchment/90 mt-8 leading-snug">
                "The quality of your relationships determines the quality of your capital."
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <p className="text-stone text-lg leading-relaxed">
                EQ Capital Group is a premier strategic capital advisory and investment banking platform that partners with visionary founders, family offices, institutional investors and private companies to unlock growth, build meaningful relationships and create lasting impact.
              </p>
              <p className="text-stone leading-relaxed mt-6">
                We believe capital is more than money — it is energy, trust, relationships and responsibility. Traditional investment banking focuses on transactions. We focus on <span className="text-parchment">transformation</span>. Every engagement begins with understanding your vision before introducing capital, and we become an extension of your executive team.
              </p>
            </Reveal>

            <div className="grid sm:grid-cols-2 gap-4 mt-12">
              {CARDS.map((c, i) => (
                <Reveal key={c.label} delay={0.2 + i * 0.1}>
                  <div className="border border-hairline p-8 h-full hover:border-gold/50 transition-colors duration-500">
                    <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold">{c.label}</span>
                    <p className="text-parchment/85 leading-relaxed mt-4 text-sm">{c.body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 border-t border-hairline pt-14 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-5">
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Our Philosophy</span>
              <p className="font-serif font-light text-4xl sm:text-5xl text-parchment tracking-tight mt-5">
                EQ isn't just our name.<br /><span className="italic text-gold">It is our philosophy.</span>
              </p>
            </div>
            <div className="lg:col-span-7">
              <div className="font-serif text-2xl sm:text-3xl font-light leading-snug text-parchment/80 space-y-1">
                <p>Money follows confidence.</p>
                <p>Confidence follows execution.</p>
                <p>Execution follows leadership.</p>
                <p>Leadership begins with <span className="text-gold">Emotional Intelligence.</span></p>
              </div>
              <p className="text-stone leading-relaxed mt-6 max-w-xl">
                Companies led by emotionally intelligent founders build stronger cultures, create deeper investor confidence and attract better long-term partners.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
